<template>
  <div class="upload-docs">
    <div class="upload-docs_blocks" v-if="docsVal.length">
      <div class="upload-docs_blocks_item" v-for="(v, i) in docsVal" :key="`docsv-${ i }`">
        <a
          :href="
            v.path.match(/collections\/+.*$/g)
              ? storage + v.path.match(/collections\/+.*$/g)[0]
              : '/not-found.svg'
          "
          class="body-1"
          target="_blank"
        >
          {{ v.name }}
        </a>
        <v-icon large>
          mdi-file-document
        </v-icon>
        <div class="upload-docs_blocks_item_remove" @click="remove(i)">
          <v-icon color="red" dense>
            mdi-trash-can-outline
          </v-icon>
        </div>
      </div>
      <div class="upload-docs_blocks_item" @click="dialog = true" style="cursor: pointer">
        <v-icon color="red" large>
          mdi-plus
        </v-icon>
      </div>
    </div>
    <v-btn v-else :color="color" @click="dialog = true">
      <slot />
    </v-btn>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ getButtonLabel }}
        </v-card-title>

        <v-card-text>
          <v-file-input
            v-model="docs"
            class="mt-4"
            accept="image/jpg, image/jpeg, image/png, image/gif, image/svg, image/svg+xml, image/webp, application/pdf, application/msword, application/vnd.oasis.opendocument.text, application/vnd.oasis.opendocument.text-template, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/xml, text/xml, text/plain"
            multiple
            :label="label"
            outlined
            :loading="loading"
            :disabled="loading"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn class="mr-2" text @click="dialog = false">
            Отмена
          </v-btn>
          <v-btn color="primary" text @click="_handleLoader">
            Загрузить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    /* eslint-disable-next-line */
    name: 'upload-docs',
    model: {
      prop: 'docsVal',
      event: 'input',
    },
    props: {
      label: {
        type: String,
        default: '',
      },
      color: {
        type: String,
        default: '',
      },
      dialogWidth: {
        type: String,
        default: '500',
      },
      docsVal: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {
        docs: [],
        remoteDocs: [],
        loading: false,
        dialog: false,
        text: '',
      }
    },
    computed: {
      getButtonLabel () {
        return this.text || 'Загрузить документы'
      },
      storage () {
        return this.$store.getters['api/storage'] + '/doc/'
      },
    },
    methods: {
      async _handleLoader () {
        this.loading = true

        const promiseList = []

        this.docs.forEach((item) => {
          if (
            [
              'image/jpg',
              'image/jpeg',
              'image/png',
              'image/gif',
              'image/svg',
              'image/svg+xml',
              'image/webp',
              'application/pdf',
              'application/msword',
              'application/vnd.oasis.opendocument.text',
              'application/vnd.oasis.opendocument.text-template',
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
              'application/vnd.ms-excel',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              'application/xml',
              'text/xml',
              'text/plain',
            ].includes(item.type)
          ) {
            const formData = new FormData()
            formData.append('file', item)
            formData.append('path', '/collections/uploads/docs')

            const sendMethod = async () => {
              await this.$store
                .dispatch('upload/uploadDoc', formData)
                .then((res) => {
                  this.remoteDocs = this.docsVal
                  this.remoteDocs.push({
                    path: res.data.fullPath,
                    name: item.name,
                  })
                })
                .catch((err) => console.log(err))
            }
            promiseList.push(sendMethod())
          }
        })

        await Promise.all(promiseList)
          .then(() => {
            this.loading = false
            this.dialog = false
            this.text = `${this.docs.length} файлов...`
            this.$emit('input', this.remoteDocs)
          })
          .catch((err) => console.log(err))
      },
      remove (index = null) {
        if (index !== null) {
          this.$emit('input', this.docsVal.filter((v, i) => i !== index))
        } else {
          console.error('Не указан индекс удаляемого объекта')
        }
      },
    },
  }
</script>

<style lang="less">
.upload-docs {
  &_blocks {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;

    &_item {
      width: 150px;
      height: 150px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      border: 1px solid rgb(194, 194, 194);
      border-radius: 4px;
      margin-right: 8px;
      position: relative;
      overflow: hidden;

      a {
        color: #232323;
        text-align: center;
        text-decoration: none;
        cursor: pointer;
      }

      &_remove {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(255, 255, 255, 0.5);
        border-bottom-left-radius: 4px;
        transform-origin: top right;
        transition: all 0.25s;
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 5;

        &:hover {
          transform: scale(1.2);
        }
      }
    }
  }
}
</style>
